import React from 'react';
import { useContext, useState } from 'react';
import { Checkbox, Link, Container, Button, Box, Typography, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Spinner } from '/@/app/components/Spinner';
import { messageStackState } from "/@/app/states/messageStackState";

//
import { AppContext } from '/@/app/AppContext';
import { useApi} from '/@/app/Api';
import { route } from '/@/app/routes';


const Item = styled(Box)(({ theme }) => ({
    backgroundColor: '#f5f7fb',
    ...theme.typography.body2,

    borderRadius: theme.shape.borderRadius * 1.5,
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(3),
    },
    [theme.breakpoints.up('lg')]: {
        padding: theme.spacing(4.5),
    },
    //
    textAlign: "left",
    color: theme.palette.text.primary,
}));


export const AcceptTermsView = () => {
    const api=useApi();
    const { bootstrapData } = useContext(AppContext);
    const user = bootstrapData.user;

    const [termsAccepted, setTermsAccepted] = useState(user.terms_accepted !== null );

    const handleTermsAccepted = (event) => {
        setTermsAccepted(event.target.checked);
    };

    const [saving, setSaving] = useState(false);
    const handleSave = () => {
        if (saving) {
            return;
        }
        if (!termsAccepted) {
            messageStackState.addMessage({text: "Примите Пользовательское Соглашение, чтобы продолжить", tags: "error", autoHide: 2000});
            return;
        }
        setSaving(true);
        api.request(`cabinet/user/terms/`,{ "terms_accepted": termsAccepted, }, { method: 'PUT', })
	.then(() => {
            location.href = route("/");  // reload just because user's data changes are not reactive.
        }).finally(() => {
            setSaving(false);
        });
    }

    return (
        <Container maxWidth="md">
            <Item>
                <Grid container spacing={2} sx={{textAlign: "center" }}>
                    <Grid item xs={12} md={12}>
                        <Typography variant="body1" gutterBottom sx={{
                        }}>
                            <Checkbox
                                checked={termsAccepted}
                                readOnly={saving}
                                onChange={handleTermsAccepted}
                                sx={{ display:"inlineBlock" }}
                            />
                            Я принимаю{" "}
                            <Link sx={{ display:"inlineBlock" }} href="https://nestarenie.ru/soglasie-s-rassylkoj.html" target="_blank">Пользовательское Соглашение</Link>{" "}
                            и{" "}
                            <Link sx={{ display:"inlineBlock" }} href="https://nestarenie.ru/politika-konfidenczialnosti.html" target="_blank">Политику Конфиденциальности</Link>{" "}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleSave}
                                disabled={saving || !termsAccepted}
                            >Принять</Button>
                            {!termsAccepted &&
                                <Typography variant="body2" sx={{ mt: 2 }}>
                                    Поставьте галочку, чтобы принять.
                                </Typography>
                            }
                        </>
                    </Grid>
                </Grid>
            </Item>
            {saving && <Box sx={{textAlign: "center"}}><Spinner size={60} delay={500} sx={{mt:2}} /></Box>}
        </Container>
    )
}
